import {QrCode} from '../../../../../../../components/QrCode/QrCode';
import PriceWithDiscount from '../../../../../../shopping-basket/components/PriceWithDiscount';

interface Iprops {
  price: number;
  discount_price: number;
  count: number;
  title: string;
  image: string;
  quantity: number;
  link?: string;
  isOrderPending?: boolean;
}

const MyStoreOrderedItems = ({
  price,
  discount_price,
  title,
  image,
  count,
  quantity,
  link,
  isOrderPending = false,
}: Iprops) => {
  return (
    <div className="flex justify-between px-4 pt-4 rounded-lg bg-zinc-100">
      <div className="flex gap-2">
        <div className="relative size-14">
          <span className="flex absolute -left-2 justify-center items-center text-sm font-medium text-gray-800 bg-green-50 rounded-full size-5">
            {count}
          </span>
          <img src={image} className={'w-full h-full'} alt="عکس سفارش" />
        </div>
        <div className="flex flex-col gap-3 pb-3 mt-3 text-md">
          <span className="line-clamp-1">{title}</span>
          <PriceWithDiscount
            className="col-span-2"
            originalPrice={price * quantity}
            discountPrice={discount_price}
          />
        </div>
      </div>
      {link && !isOrderPending && (
        <div className="flex justify-end items-end pb-3">
          <QrCode link={link} size="xLarge" />
        </div>
      )}
    </div>
  );
};

export default MyStoreOrderedItems;
